import { timestampSchema } from '@/utility'
import { z } from 'zod'

export const activeDeploymentSchema = z.object({
  /** uid of the publish record for the last successful deployment */
  uid: z.string(),
  /** subdomain or custom domain */
  domain: z.string(),
  /** timestamp of the last successful deployment */
  publishedAt: timestampSchema,
})

/** Client render information about the last deployment */
export type ActiveDeployment = z.infer<typeof activeDeploymentSchema>
